<template>
    <div class="search_nav">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="轮播类型：">
          <el-select v-model="formInline.bannerType" placeholder="请选择" style="width: 150px;">
            <el-option label="全部" value="" />
            <el-option label="通知/公告" :value="1" />
            <el-option label="广告宣传" :value="2" />
            <el-option label="其他" :value="3" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <div class="button_group">
            <el-button type="primary" @click="getList">搜索</el-button>
            <el-button type="primary" @click="refresh">刷新</el-button>
            <el-button type="success" @click="openAdd">新增轮播图</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  
    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <el-table-column label="序号" width="60">
        <template #default="scope">
          <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="轮播序号" width="100">
        <template #default="scope">
          <span>{{ scope.row.sortOrder || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="轮播类型" width="120">
        <template #default="scope">
          <span>{{ bannerTypeFormat(scope.row.bannerType) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="正文图片" show-overflow-tooltip>
        <template #default="scope">
          <el-image v-if="scope.row.contentImage" :src="scope.row.contentImage" :preview-src-list="[scope.row.contentImage]" style="width: 40px; height: 40px;" fit="cover" />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="轮播标题" width="230" show-overflow-tooltip>
        <template #default="scope">
          <span>{{ scope.row.title || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="链接地址" width="300" show-overflow-tooltip>
        <template #default="scope">
          <span>{{ scope.row.linkUrl || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="180">
        <template #default="scope">
          <span>{{ scope.row.createTime || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="失效时间" width="180">
        <template #default="scope">
          <span>{{ scope.row.expireTime || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100" fixed="right">
        <template #default="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            @change="toggleStatus(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template #default="scope">
          <el-button size="small" type="primary" @click="handleEdit(scope.row)">修改</el-button>
          <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />
  
    <!-- 新增/编辑弹窗 -->
    <el-dialog v-model="dialogVisible" :title="isEdit ? '修改轮播图' : '新增轮播图'" width="600px" :close-on-click-modal="false">
      <el-form :model="bannerForm" label-position="right" label-width="100px">
        <el-form-item label="轮播类型：" prop="bannerType">
          <el-select v-model="bannerForm.bannerType" placeholder="请选择轮播类型" style="width: 100%;" @change="handleBannerTypeChange">
            <el-option label="通知/公告" :value="1" />
            <el-option label="广告宣传" :value="2" />
            <el-option label="其他" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="bannerForm.bannerType === 1" label="轮播标题：" prop="title">
          <el-input v-model="bannerForm.title" placeholder="请输入轮播标题" />
        </el-form-item>
        <el-form-item label="轮播图片：" prop="imageUrl">
          <el-upload
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
            list-type="picture-card"
            :file-list="imageFileList"
            :limit="1"
          >
            <i class="el-icon-plus">+</i>
          </el-upload>
          <div class="upload-tip">建议尺寸：702*200px</div>
        </el-form-item>
        <el-form-item v-if="bannerForm.bannerType === 1" label="正文图片：" prop="bodyImage">
          <el-upload
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleBodyImageSuccess"
            :before-upload="beforeUpload"
            list-type="picture-card"
            :file-list="bodyImageFileList"
            :limit="1"
          >
            <i class="el-icon-plus">+</i>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="bannerForm.bannerType === 2" label="*链接地址：" prop="linkUrl">
          <el-input v-model="bannerForm.linkUrl" placeholder="请输入链接地址" />
        </el-form-item>
        <el-form-item v-if="bannerForm.bannerType === 1" label="正文内容：" prop="bodyContent">
          <RichEditor v-model="bannerForm.bodyContent" :maxlength="500"></RichEditor>
        </el-form-item>
        <el-form-item label="排序序号：" prop="sortOrder">
          <el-input v-model.number="bannerForm.sortOrder" type="number" placeholder="请输入排序序号" />
        </el-form-item>
        <el-form-item label="失效时间：" prop="expireTime">
          <el-date-picker
            v-model="bannerForm.expireTime"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="选择失效时间"
            style="width: 100%;"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveBanner">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </template>
  
  <script>
  import { ElMessage, ElMessageBox } from 'element-plus';
  import RichEditor from '@/components/RichEditor.vue';
  
  export default {
  name: 'BannerManage',
  components: {
    RichEditor
  },
  data() {
  return {
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      isEdit: false,
      formInline: {
          bannerType: ''
      },
      bannerForm: {
          id: '',
          bannerType: '',
          title: '',
          imageUrl: '',
          bodyImage: '',
          linkUrl: '',
          bodyContent: '',
          sortOrder: '',
          expireTime: '',
          status: 0
      },
      imageFileList: [],
      bodyImageFileList: [],
      uploadUrl: '',
      uploadHeaders: {
          'Authorization': localStorage.getItem('token')
      }
  }
  },
  mounted() {
  this.uploadUrl = process.env.NODE_ENV === 'development' ? '/api' + this.$store.state.platformApi + 'oss/upload' : process.env.VUE_APP_API_URL + '/' + this.$store.state.platformApi + 'oss/upload';
  this.getList();
  },
  methods: {
  // 获取列表
  getList() {
      let that = this;
      let param = {
          page: that.currentPage,
          pageSize: that.pageSize
      };
      Object.keys(this.formInline).forEach(key => {
          if (this.formInline[key]) {
              param[key] = this.formInline[key];
          }
      });
      that.$axios.post(that.$store.state.platformApi + "banner/page", JSON.stringify(param)).then(result => {
          if (result.code == 200) {
              that.tableData = result.data.records;
              that.total = result.data.total;
          }
      });
  },
  // 轮播类型格式化
  bannerTypeFormat(type) {
      switch (type) {
          case 1:
              return '通知/公告';
          case 2:
              return '广告宣传';
          case 3:
              return '其他';
          default:
              return '-';
      }
  },
  // 轮播类型变化
  handleBannerTypeChange() {
      if (this.bannerForm.bannerType !== 1) {
          this.bannerForm.title = '';
          this.bannerForm.bodyImage = '';
          this.bannerForm.bodyContent = '';
          this.bodyImageFileList = [];
      }
      if (this.bannerForm.bannerType !== 2) {
          this.bannerForm.linkUrl = '';
      }
  },
  // 打开新增弹窗
  openAdd() {
      this.isEdit = false;
      this.bannerForm = {
          id: '',
          bannerType: '',
          title: '',
          imageUrl: '',
          bodyImage: '',
          linkUrl: '',
          bodyContent: '',
          sortOrder: 1,
          expireTime: '',
          status: 1
      };
      this.imageFileList = [];
      this.bodyImageFileList = [];
      this.dialogVisible = true;
  },
  // 打开编辑弹窗
  handleEdit(row) {
      this.isEdit = true;
      this.bannerForm = {
          id: row.id,
          bannerType: row.bannerType,
          title: row.title || '',
          imageUrl: row.imageUrl,
          bodyImage: row.bodyImage || '',
          linkUrl: row.linkUrl || '',
          bodyContent: row.bodyContent || '',
          sortOrder: row.sortOrder,
          expireTime: row.expireTime,
          status: row.status
      };
      this.imageFileList = row.imageUrl ? [{ url: row.imageUrl }] : [];
      this.bodyImageFileList = row.bodyImage ? [{ url: row.bodyImage }] : [];
      this.dialogVisible = true;
  },
  // 删除
  handleDelete(row) {
      let that = this;
      that.$confirm('确认删除该轮播图吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
          that.$axios.post(that.$store.state.platformApi + "banner/delete/" + row.id, {}).then(result => {
              if (result.code === 200) {
                  that.$message.success('删除成功');
                  that.getList();
              }
          });
      }).catch(() => {
          // 取消操作
      });
  },
  // 切换状态
  toggleStatus(row) {
      let that = this;
      that.$axios.post(that.$store.state.platformApi + "banner/toggle/" + row.id, {}).then(result => {
          if (result.code === 200) {
              that.$message.success(row.status == 1 ? '已启用' : '已禁用');
          } else {
              row.status = row.status == 1 ? 0 : 1;
          }
      });
  },
  // 保存轮播图
  saveBanner() {
      let that = this;
      if(that.bannerForm.bannerType === 2 && !that.bannerForm.linkUrl) {
          that.$message.error('请输入链接地址');
          return;
      }
      let url = that.isEdit ? "banner/update" : "banner/add";
      that.$axios.post(that.$store.state.platformApi + url, JSON.stringify(that.bannerForm)).then(result => {
          if (result.code === 200) {
              that.$message.success(that.isEdit ? '修改成功' : '新增成功');
              that.dialogVisible = false;
              that.getList();
          }
      });
  },
  // 图片上传成功
  handleUploadSuccess(response, file, fileList) {
      if (response.code === 200) {
          this.bannerForm.imageUrl = response.data.url;
          this.imageFileList = fileList;
      }
  },
  // 正文图片上传成功
  handleBodyImageSuccess(response, file, fileList) {
      if (response.code === 200) {
          this.bannerForm.bodyImage = response.data.url;
          this.bodyImageFileList = fileList;
      }
  },
  // 图片上传前
  beforeUpload(file) {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
          this.$message.error('请上传图片格式文件');
          return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
          this.$message.error('图片大小不能超过2MB');
          return false;
      }
      return true;
  },
  // 刷新
  refresh() {
      this.formInline = {
          bannerType: ''
      };
      this.currentPage = 1;
      this.getList();
  },
  // 分页大小改变
  handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
  },
  // 当前页改变
  handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
  }
  }
  }
  </script>
  
  <style lang="scss" scoped>
  .search_nav{
  padding: 15px;
  background: #fff;
  margin-bottom: 15px;
  }
  .button_group{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  button{
      margin-left: 10px;
  }
  }
    .dialog-footer{
  text-align: right;
  }
  .upload-tip{
  width: 100%;
  margin-top: 4px;
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  }
  </style>